import _ from 'lodash';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'amount' implicitly has an 'any' type.
const convertToCurrencyFormat = (amount) => (_.isNaN(amount) || _.isNil(amount) ? '' : amount.toLocaleString());

export { convertToCurrencyFormat };
